import { getSessionStore } from "@/utils/sessionStorage";

export function addTokenToUrl(url) {
  const access_token = getSessionStore("access_token");
  if (!url || !access_token || String(url).indexOf("access_token=") !== -1) {
    return url;
  }

  const urlString = String(url);
  if (urlString.indexOf("/#/") !== -1) {
    return url;
  }

  let tokenValue = access_token;
  try {
    const tokenObj = JSON.parse(access_token);
    tokenValue = tokenObj.value || tokenObj.access_token || access_token;
  } catch (e) {}

  const hashIndex = urlString.indexOf("#");
  const beforeHash = hashIndex === -1 ? urlString : urlString.slice(0, hashIndex);
  const afterHash = hashIndex === -1 ? "" : urlString.slice(hashIndex);
  const separator = beforeHash.indexOf("?") === -1 ? "?" : "&";
  return `${beforeHash}${separator}access_token=${encodeURIComponent(tokenValue)}${afterHash}`;
}

export function openWindowWithToken(url, target = "_blank", features = "") {
  window.open(addTokenToUrl(url), target, features);
}
